import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import WeekText from "../../Main/Prevention/Week/WeekText.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/svo/svoData.json";

export default function ParticipantsSVO() {
  useSEO(seoConfig.participantsSVO);

  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="weekpage__title">Участникам СВО</h1>
      <div>
        <WeekText data={data} />
      </div>
    </section>
  );
}
